// src/de-DE.js
export default {
    "scheduler": {
      "editorValidationRequired": "Feld ist erforderlich.",
      "editorValidationStart": "Startzeit muss vor der Endzeit liegen.",
      "editorValidationEnd": "Endzeit muss nach der Startzeit liegen.",
      "allEvents": "Alle Ereignisse",
      "allDay": "Ganztägig",
      "today": "Heute",
      "dayViewTitle": "Tag",
      "monthViewTitle": "Monat",
      "weekViewTitle": "Woche",
      "workWeekViewTitle": "Arbeitswoche",
      "timelineViewTitle": "Zeitachse",
      "agendaViewTitle": "Agenda",
      "deleteTitle": "Löschen",
      "previousTitle": "Vorherige",
      "nextTitle": "Nächste",
      "showFullDay": "Ganzen Tag anzeigen",
      "showWorkDay": "Arbeitsstunden anzeigen",
      "editorOccurrence": "Aktuelles Ereignis bearbeiten",
      "editorSeries": "Serie bearbeiten",
      "editorRecurringConfirmation": "Möchten Sie nur dieses Ereignis oder die gesamte Serie bearbeiten?",
      "editorRecurringDialogTitle": "Wiederkehrendes Element bearbeiten",
      "editorSave": "Speichern",
      "editorCancel": "Abbrechen",
      "editorDelete": "Löschen",
      "editorTitle": "Ereignis",
      "editorEventTitle": "Titel",
      "editorEventStart": "Start",
      "editorEventStartTimeZone": "Startzeitzone",
      "editorEventEnd": "Ende",
      "editorEventEndTimeZone": "Endzeitzone",
      "editorEventAllDay": "Ganztägiges Ereignis",
      "editorEventDescription": "Beschreibung",
      "editorEventSeparateTimeZones": "Ende in anderer Zeitzone",
      "editorEventTimeZone": "Zeitzone angeben",
      "recurrenceEditorRepeat": "Wiederholen",
      "recurrenceEditorDailyInterval": "Tag(e)",
      "recurrenceEditorDailyRepeatEvery": "Wiederhole alle",
      "recurrenceEditorWeeklyInterval": "Woche(n)",
      "recurrenceEditorWeeklyRepeatEvery": "Wiederhole alle",
      "recurrenceEditorWeeklyRepeatOn": "Wiederhole am",
      "recurrenceEditorMonthlyDay": "Tag",
      "recurrenceEditorMonthlyInterval": "Monat(e)",
      "recurrenceEditorMonthlyRepeatEvery": "Wiederhole alle",
      "recurrenceEditorMonthlyRepeatOn": "Wiederhole am",
      "recurrenceEditorYearlyOf": "von",
      "recurrenceEditorYearlyRepeatEvery": "Wiederhole alle",
      "recurrenceEditorYearlyRepeatOn": "Wiederhole am",
      "recurrenceEditorYearlyInterval": "Jahr(e)",
      "recurrenceEditorFrequenciesDaily": "Täglich",
      "recurrenceEditorFrequenciesMonthly": "Monatlich",
      "recurrenceEditorFrequenciesNever": "Nie",
      "recurrenceEditorFrequenciesWeekly": "Wöchentlich",
      "recurrenceEditorFrequenciesYearly": "Jährlich",
      "recurrenceEditorOffsetPositionsFirst": "Erster",
      "recurrenceEditorOffsetPositionsSecond": "Zweiter",
      "recurrenceEditorOffsetPositionsThird": "Dritter",
      "recurrenceEditorOffsetPositionsFourth": "Vierter",
      "recurrenceEditorOffsetPositionsLast": "Letzter",
      "recurrenceEditorWeekdaysDay": "Tag",
      "recurrenceEditorWeekdaysWeekday": "Wochentag",
      "recurrenceEditorWeekdaysWeekendday": "Wochenendtag",
      "recurrenceEditorEndAfter": "Nach",
      "recurrenceEditorEndOccurrence": "Ereignis(se)",
      "recurrenceEditorEndLabel": "Ende",
      "recurrenceEditorEndNever": "Nie",
      "recurrenceEditorEndOn": "Am",
      "deleteConfirmation": "Sind Sie sicher, dass Sie dieses Ereignis löschen möchten?",
      "deleteRecurringConfirmation": "Möchten Sie nur dieses Ereignis oder die gesamte Serie löschen?",
      "deleteOccurrence": "Aktuelles Ereignis löschen",
      "deleteSeries": "Serie löschen",
      "deleteDialogTitle": "Ereignis löschen",
      "deleteRecurringDialogTitle": "Wiederkehrendes Element löschen",
      "dateTitle": "Datum",
      "timeTitle": "Zeit",
      "eventTitle": "Ereignis",
      "noEvents": "Keine Ereignisse"
    },
    "custom": {
      "teamEfficiency": "Mitarbeiter-Effizienz",
      "teamMembers": "Teammitglieder",
      "dashboard": "Dashboard",
      "users": "Benutzer",
      "jobs": "Auftragsverwaltung",
      "customers": "Kundenverwaltung",
      "planning": "Planung",
      "profile": "Profil",
      "info": "Info",
      "settings": "Settings",
      "language": "Sprache",
      "trend": "Trend",
      "volume": "Volumen",
      "myTeam": "Mein Team",
      "allTeams": "Alle Teams",
      "teamCalendar": "Team-Kalender",
      "saveChanges": "Änderungen speichern",
      "cancel": "Abbrechen",
      "warehouse": "EXPLOSERV Bautagebuch",
      "startFreeTrial": "Kostenlose Testversion starten",
      "buyNow": "Jetzt kaufen",
      "getSource": "Quellcode auf GitHub holen",
      "demoInfo": "Diese Demo-Anwendung wurde mit den folgenden KendoReact-Komponenten und dem KendoReact-Standardthema erstellt.",
      "firstName": "Vorname",
      "middleName": "Zweiter Name",
      "lastName": "Nachname",
      "email": "E-Mail-Adresse",
      "phoneNumber": "Telefonnummer",
      "country": "Land",
      "biography": "Kurze Biografie",
      "public": "In öffentliches Verzeichnis aufnehmen",
      "team": "Team",
      "employee": "Mitarbeiter",
      "contactName": "Kontaktname",
      "jobTitle": "Berufsbezeichnung",
      "status": "Status",
      "performance": "Leistung",
      "rating": "Bewertung",
      "engagement": "Engagement",
      "budget": "Budget",
      "contacts": "Kontakte",
      "address": "Adresse",
      "phone": "Telefon",
      "gridSearch": "In allen Spalten suchen...",
      "exportExcel": "Nach Excel exportieren",
      "exportPdf": "Nach PDF exportieren"
    }
  };